import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { getGirosComerciales } from './girosComerciales';
import { getTiposDeGirosComerciales } from './tiposDeGiroComercial';

export const baseURI = '/empresas/empresas/';

/**
 * GET Empresas
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getEmpresas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Empresa
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEmpresa = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    if (process.env.REACT_APP_ENV_NAME === 'oaxaca' || process.env.REACT_APP_ENV_NAME === 'navojoa') {
      const tipos = await getTiposDeGirosComerciales();
      response.data._giros_comerciales = await getGirosComerciales({ empresa: id });
      response.data._giros_comerciales = response.data._giros_comerciales
        .map((g) => `- ${tipos.find((t) => t.id === g.tipo_de_giro_comercial)?.descripcion}`).join('\n');
    }
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * GET Horarios Empresa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<Array<object>>}
 */
export const getHorariosEmpresa = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Empresa
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEmpresa = async (_values, accion = 'EMPRESA') => {
  try {
    const values = getFormattedValues(_values);
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(baseURI, values, {
      accionInf,
      idPadron: padronesEnum.COMERCIO_INFORMAL,
      clave: values.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Empresa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEmpresa = async (id, _values, accion = 'EMPRESA') => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${baseURI}${id}`, values, {
      accionInf,
      idPadron: padronesEnum.COMERCIO_INFORMAL,
      clave: values.clave,
    });
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Empresa
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEmpresa = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
